import React from 'react';
import { withRouter } from 'react-router-dom';
import get from 'lodash/get';
import { connect } from 'react-redux';
import {
  Grid, Dialog, DialogContent, DialogTitle, DialogActions,
} from '@mui/material';

import {
  getRepairTicketCategory,
} from '../../lib/repair-ticket-categories';
import ErrorMessage from '../common/error-message';
import VehicleSaveAndCancelButtons from '../common/save-and-cancel-buttons';
import RepairTicketEditForm from './repair-ticket-edit-form';
import CreatedAndUpdatedDisplay from '../common/created-updated-display';

const styles = {
  dialogPaper: {
    minHeight: '70vh',
    maxHeight: '70vh',
  },
  button: {
    width: '140px',
    fontSize: '12px',
  },

};

class RepairTicketEditModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      repairTicket: props.repairTicket,
      error: false,
    };

    this.handleSave = this.handleSave.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleErrorChange = this.handleErrorChange.bind(this);
    this.handleButtonEventChange = this.handleButtonEventChange.bind(this);
    this.handleVehicleChange = this.handleVehicleChange.bind(this);
  }

  get repairTicketCategories() {
    const { repairTicketCategories } = this.props;
    const { repairTicket } = this.state;
    const { vehicle } = repairTicket;
    const marketVehicles = get(this, 'props.vehicles', []);
    const match = marketVehicles.find((v) => v._id === repairTicket.vehicleId);
    let categories = [];
    if (match) {
      categories = getRepairTicketCategory(match.brand, match.type, repairTicketCategories);
    } else if (vehicle) {
      categories = getRepairTicketCategory(vehicle.brand, vehicle.type, repairTicketCategories);
    }
    return categories;
  }

  handleVehicleChange(newVehicleId) {
    const { repairTicket } = this.state;

    const newRepairTicket = {
      ...repairTicket,
      vehicleId: newVehicleId,
    };

    this.setState({ repairTicket: newRepairTicket });
  }

  handleButtonEventChange(event) {
    const { repairTicket } = this.state;
    const { name, value } = event.currentTarget;
    const newRepairTicket = {
      ...repairTicket,
      [name]: value,
    };
    this.setState({ repairTicket: newRepairTicket, error: false });
  }

  handleChange(event) {
    const { repairTicket } = this.state;
    const { name, value } = event.target;
    const newRepairTicket = {
      ...repairTicket,
      [name]: value,
    };

    this.setState({ repairTicket: newRepairTicket, error: false });
  }

  handleErrorChange(event) {
    const { repairTicket } = this.state;
    const { name, value } = event.target;
    const newRepairTicket = {
      ...repairTicket,
      [name]: value,
    };
    this.setState({ repairTicket: newRepairTicket, error: false });
  }

  handleSave(event, commentOnly) {
    const { repairTicket } = this.state;
    const { categoryId, vehicleId, description } = repairTicket;
    const { editing, onSave } = this.props;

    if (!categoryId) {
      return this.setState({
        error: true,
        errorMessage: 'Please choose a category.',
      });
    }

    if (!vehicleId) {
      return this.setState({
        error: true,
        errorMessage: 'Please select a vehicle.',
      });
    }

    if (!description) {
      return this.setState({
        error: true,
        errorMessage: 'Please enter a description.',
      });
    }

    onSave(repairTicket, editing, commentOnly);
  }

  render() {
    const { repairTicket, errorMessage, error } = this.state;
    const {
      isOpen,
      onCancel,
      editing,
      vehicles,
      tz,
    } = this.props;
    const { humanId } = repairTicket;
    const titleString = editing ? humanId && `Repair Ticket: ${humanId}` : 'Create a repair ticket';

    return (
      <Dialog
        PaperProps={{ style: styles.dialogPaper }}
        open={isOpen}
        fullWidth
        maxWidth="xs"
        onClose={onCancel}
      >
        <DialogTitle>
          <Grid container justifyContent="space-between">
            <Grid item>
              {titleString}
            </Grid>
            {error && <ErrorMessage errorMessage={errorMessage} />}
          </Grid>
          <Grid item style={styles.field}>
            {editing
              && (
                <CreatedAndUpdatedDisplay
                  item={repairTicket}
                  tz={tz}
                />
              )}
          </Grid>
        </DialogTitle>
        <DialogContent>
          <RepairTicketEditForm
            handleChange={this.handleChange}
            handleErrorChange={this.handleErrorChange}
            handleButtonEventChange={this.handleButtonEventChange}
            handleVehicleChange={this.handleVehicleChange}
            repairTicket={repairTicket}
            editing={editing}
            onSaveComment={this.handleSave}
            vehicles={vehicles}
            tz={tz}
          />
        </DialogContent>
        <DialogActions>
          <VehicleSaveAndCancelButtons
            onCancel={onCancel}
            onSave={this.handleSave}
          />
        </DialogActions>
      </Dialog>
    );
  }
}

const mapStateToProps = ({ settings }) => ({
  repairTicketCategories: settings.repairTicketCategories,
  repairTicketErrorCodes: settings.repairTicketErrorCodes,
});

export default connect(mapStateToProps)(withRouter(RepairTicketEditModal));
